<template>
<tbody class="table-font" style="font-size:13px;" v-if="item!=null">
    <tr>
        <td>{{index+1}}</td>
         <td><span v-if="item.enteredby!=null">{{item.enteredby.name}}<br>
            {{moment(item.created_at).format('DD-MM-YYYY H:m A')}}</span>
        </td>
        <td>{{ item.advisor?.name}}<br>{{ item.advisor?.generatedid}}<br>
            {{ item.advisor!=null ? moment(item.created_at).format('DD-MM-YYYY H:m A') : '' }}  
        </td>
        <td>{{ item.customer?.generatedid}}</td>
        <td>
            <span v-if="item.customer!=null">{{item.customer.name}}</span>
            <span v-else>{{item.customername}}</span>
        </td>
        <td>
            <span v-if="item.customer!=null"><display-mobiles :mobiles="item.customer?.mobiles"></display-mobiles></span>
            <span v-else>{{ item.customermobile}}</span>
        </td>
        <td>
            <span v-if="item.customer!=null"><display-first-address :addresses="item.customer?.addressess"></display-first-address></span>
            <span v-else>{{item.customeraddress}}</span>
        </td> 
        <td>{{item.complaintno}}</td> 
        <td style="font-size:10px ;">
            <div>
                <div>
                    <span v-if="item.product!=null && item.product.category!=null">{{item.product.category.name}}</span>
                    <span v-if="item.product!=null && item.product.attribute!=null">
                        <div v-for="company in item.product.attribute" :key="company.id">
                        {{ getcompany(company.attribute_value_ids) }}
                        </div>
                    </span>
                    <span >{{item.product?.name}}</span>&nbsp;
                </div>
            </div>
        </td>
        <td>{{item.remark}}</td>
        <td>{{item.updatedremark}}</td>
        <td>{{ item.approveby?.name ?? '' }} <br> {{ item.approvedate!=null? moment(item.approvedate).format('DD-MM-YYYY H:m A'):'' }}</td>
        <td>{{ item.advisor?.name}}<br>{{ item.advisor?.generatedid}}</td>
        <td>
            <span v-if="item.deliveryboy" style="font-weight:600">{{ item.deliveryboy.name }}</span>
            <span v-else style="color:#999">Not assigned</span>
            <div v-if="item.estimated_delivery_at" style="font-size:11px">ETA: {{ moment(item.estimated_delivery_at).format('DD-MM-YYYY hh:mm A') }}</div>
        </td>
        <!-- <td><span v-if="item.followby!=null">{{item.followby.name}}</span></td> -->
        <td> <span v-if="item.disposeby!=null">{{ item.disposeby.name }}<br>{{ item.disposedate}}</span></td>
        <td>
            <span :style="item.status==0 || item.status==2 || item.status==6?'color:red':'color:green'">{{ ordermethod(item)}}</span><br>
            <span>{{ item.enteredby?.generatedid??'' }} <br>{{ moment(item.updated_at).format('DD-MM-YYYY H:m A' ) }}</span>
        </td>
        <!-- <td><button class="badge btn-prime btn-xs" @click="showchats()">conversation</button></td> -->
        <td><button class="badge btn-primary-delete btn-xs" @click="enabledisposeoff()">Conversation</button></td>
    </tr>
    <tr v-if="visitcomments">
        <td colspan="17">
            <order-conversation :item="item" :show="false"></order-conversation>
        </td>
    </tr>
</tbody>
</template>
<script>
import moment from 'moment'
import OrderConversation from './OrderConversation.vue'
import DisplayFirstAddress from '../../components/address/DisplayFirstAddress.vue'
import DisplayMobiles from '../../components/mobile/DisplayMobiles.vue'
import Constants from '../../components/utilities/Constants.vue';
import { mapGetters } from 'vuex';
export default {
    mixins:[Constants],
    props:['item','index'],
    components:{OrderConversation,DisplayFirstAddress,DisplayMobiles},
    data() {
        return {
            moment:moment,
            visitcomments:false
        }
    },
    computed:{
        ...mapGetters(['employees','loggedinuser','attributes'])
    },
    methods: {
        showchats(){
            this.visitcomments=!this.visitcomments
        },
        requestmethod(item){
            let type="";
            switch (item.requesttype) {
                case 1:
                    type= "QUERY";
                    break;
                case 2:
                    type= "Complaint";
                    break;
                case 3:
                    type= "Feedback";
                    break;
                case 4:
                    type= "ORDER";
                    break;
                default:
                    break;
            }
            return type;
        },
        ordermethod(item){
            let type="";
            switch (item.status) {
                case 0:
                    type= "Pending Order";
                    break;
                case 1:
                    type= "Approved";
                    break;
                case 2:
                    type= "Rejected";
                    break;
                case 3:
                    type= "Order Dispatch";
                    break;
                case 4:
                    type= "On the Way";
                    break;
                case 5:
                    type= "Order Delivered";
                    break;
                case 6:
                    // rejected, product received back at the store
                    type= (item.return_receivedbyid ?? 0) > 0 ? "Returned to Store" : "Order Rejected";
                    break;
                default:
                    break;
            }
            return type;
        },
        leadbymethod(item){
            let type="";
            switch (item.leadtype) {
                case 1:
                    type= "INCOMING CALL";
                    break;
                case 2:
                    type= "OUTGOING CALL";
                    break;
                case 3:
                    type= "NEWS PAPER ADD";
                    break;
                case 4:
                    type= "SHOW ROOM WALKIN";
                    break;
                case 5:
                    type= "HOME VISIT";
                    break;
                case 6:
                    type= "REFFERRED BY OTHER";
                    break;
                case 7:
                    type= "INTERNET";
                    break;
                case 8:
                    type= "BY ADVISOR";
                    break;
                default:
                    break;
            }
            return type;
        },
        refresh(){
            this.$parent.refresh()
        },
        enabledisposeoff(){
            this.visitcomments=!this.visitcomments
        },
        getcompany(attribute_value_ids) {
            let brand = this.attributes.find((block) => block.id == +2);
            if (typeof brand !== "undefined") {
                let companyname = brand.predefinedvalues.find(
                (a) => a.id == attribute_value_ids
                );
                if (typeof companyname != "undefined") {
                return companyname.value;
                }
            }
            return attribute_value_ids;
        },
    },
}
</script>